// extracted by mini-css-extract-plugin
export var actions = "_1k-0";
export var actionsContainer = "_1k-6";
export var border = "_1k-1";
export var childFullHeight = "_1k-d";
export var collapse = "_1k-2";
export var content = "_1k-8";
export var contentChild = "_1k-c";
export var fullscreen = "_1k-a";
export var headerContainer = "_1k-3";
export var headerRow = "_1k-5";
export var hidePadding = "_1k-9";
export var noScrollX = "_1k-e";
export var noScrollY = "_1k-f";
export var optOutTopPadding = "_1k-b";
export var pagePadding = "_1k-7";
export var profile = "_1k-g";
export var profileContainer = "_1k-h";
export var profileImage = "_1k-i";
export var profileMain = "_1k-j";
export var profileSubtitle = "_1k-l";
export var profileTitle = "_1k-k";
export var tabsWrapper = "_1k-4";
export var title = "_1k-m";